export default class TimeoutAction {
	private timeoutId: number | null

	public get isRunning(): boolean {
		return this.timeoutId !== null
	}

	constructor(action: () => void, timeout: number) {
		this.timeoutId = window.setTimeout(
			() => {
				this.timeoutId = null
				action()
			},
			timeout
		)
	}

	public clear(): void {
		if (this.timeoutId === null)
			return
		window.clearTimeout(this.timeoutId)
		this.timeoutId = null
	}
}
